module.exports = __webpack_public_path__ + "static/img/table_2.69a0600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/table_2.png
// module id = SriP
// module chunks = 0